/** @format */

import { cn } from '@clarix/ui';
import { hexToDotStyle } from '@clarix/utils';

const HEX_COLOR = /^#[0-9A-Fa-f]{6}$/;

interface MasterColorDotProps {
  color?: string | null;
  className?: string;
}

/** Small swatch for master/designation rows; falls back to muted when hex is missing or invalid. */
export function MasterColorDot({ color, className }: MasterColorDotProps) {
  if (color && HEX_COLOR.test(color)) {
    return (
      <span
        className={cn('h-2 w-2 shrink-0 rounded-full ring-1 ring-black/5', className)}
        style={hexToDotStyle(color)}
      />
    );
  }
  return (
    <span
      className={cn(
        'bg-muted-foreground/35 h-2 w-2 shrink-0 rounded-full ring-1 ring-black/5',
        className,
      )}
    />
  );
}
